<template>
  <div :class="$style.conditionRowGeolocationList">
    <DropDownSelect
      v-validate="'hasLocations'"
      data-test-id="dropDownSelect"
      label="Status"
      :name="name"
      :options="options"
      :value="model.status"
      @input="(newStatus) => setAttribute('status', newStatus)"
    />

    <LocationListSearch
      data-test-id="locationSearch"
      :value="model.locations"
      @input="(newLocations) => setAttribute('locations', newLocations)"
    />
  </div>
</template>

<script>
import { ExpressionStatus } from 'client/Security/data/Condition';
import { get } from 'lodash';
import ConditionLocations from 'client/Security/data/ConditionLocations';
import DropDownSelect from 'client/components/DropDownMenu/DropDownSelect.vue';
import LocationListSearch from 'client/Security/AuthNPoliciesAsidePanel/ConditionsSectionLegacy/LocationListSearch.vue';

export default {
  name: 'ConditionRowLocations',

  inject: ['$validator'],

  components: {
    DropDownSelect,
    LocationListSearch,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: ConditionLocations,
      default: () => new ConditionLocations(),
    },
  },

  data() {
    return {
      model: null,

      options: [
        { name: 'in country', value: ExpressionStatus.include },
        { name: 'not in country', value: ExpressionStatus.exclude },
      ],
    };
  },

  beforeMount() {
    this.model = this.value;

    this.$emit('input', this.model);

    this.$validator.extend('hasLocations', {
      getMessage: 'Location condition must include a location',
      validate: () => !!get(this.model, 'locations', []).length,
    });
  },

  methods: {
    setAttribute(key, value) {
      this.model[key] = value;

      this.$emit('input', this.model);

      this.$validator.validate(this.name);
    },
  },
};
</script>

<style module>
.conditionRowGeolocationList > * {
  margin-right: 0.4em;
}

.conditionRowGeolocationList > *:last-child {
  margin-right: 0;
}
</style>
